import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'sd-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit {

    constructor(
        public global: GlobalService
    ) { }
     getYear(): number {
  return new Date().getFullYear();
}
    ngOnInit() {
    }
}
